/*
 * @Description: 系统设置路由模块
 * @Author: mdb
 * @Date: 2022-05-31 17:40:31
 * @LastEditTime: 2023-05-19 10:28:32
 * @LastEditors: cxh
 */
import Layout from '@/layout/index.vue'

const routerItem = {
  path: '/systemSetting',
  component: Layout,
  children: [
    {
      path: 'menu',
      name: 'DcCosSystemSettingMenu',
      meta: { title: '菜单管理' },
      component: require('@/views/systemSetting/menu/index.vue').default
    },
    {
      path: 'example',
      name: 'DcCosExamples',
      meta: { title: 'Demo页' },
      component: require('@/views/example/index.vue').default
    },
    {
      path: 'example1',
      name: 'DcCosExamples1',
      meta: { title: 'Demo页1' },
      component: require('@/views/example/index1.vue').default
    },
    {
      path: 'applyServiceParam',
      name: 'DcCosApplyServiceParam',
      meta: { title: '应用业务参数' },
      component: require('@/views/systemSetting/applyServiceParam/index.vue').default
    },
    {
      path: 'visitToSign',
      name: 'base-visitToSign',
      meta: { title: '拜访签到' },
      component: require('@/views/systemSetting/visitToSign/index.vue').default
    },
    {
      path: 'visitToSignDetail',
      name: 'DcCosVisitToSignDetail',
      meta: { title: '拜访签到详情' },
      component: require('@/views/systemSetting/visitToSign/detail.vue').default
    },
    {
      path: 'appidManage',
      name: 'DcCosSystemAppidMange',
      meta: { title: 'APPID管理' },
      component: require('@/views/marketing/appidManage/index.vue').default
    },
    {
      path: 'mapManage',
      name: 'DcCosSystemMapManage',
      meta: { title: '地图管理' },
      component: require('@/views/systemSetting/mapManage/index.vue').default
    },
    {
      path: 'appManage',
      name: 'DcCosSystemAppManage',
      meta: { title: 'APP版本管理' },
      component: require('@/views/systemSetting/appManage/index.vue').default
    }
  ]
}

export default routerItem
